import { BoxIcon, Coins, Boxes, Ticket } from 'lucide-react';

import { AppTooltip } from '@/components/appTooltip';
import { cn } from '@/lib/utils';

export const ItemType = ({
  type,
  item_rarity,
  size = 64,
  className,
}: {
  type: string;
  item_rarity?: string;
  size?: number;
  className?: string;
}) => {
  const strokeWidth = size > 32 ? 1 : 2.5;
  return (
    <div
      data-rarity={item_rarity?.toLowerCase()}
      className={cn(
        `data-[rarity=common]:text-gray-900
      data-[rarity=uncommon]:text-green-900
      data-[rarity=rare]:text-blue-900
      data-[rarity=epic]:text-purple-900
      data-[rarity=legendary]:text-orange-900
      data-[rarity=mythic]:text-yellow-900`,
        className,
      )}
    >
      <AppTooltip title={`${item_rarity?.toLowerCase() ?? ''} ${type}`}>
        <div>
          {type === 'item' && (
            <BoxIcon
              size={size}
              strokeWidth={strokeWidth}
              className="self-center justify-self-center"
            />
          )}
          {type === 'bundle' && (
            <Boxes
              size={size}
              strokeWidth={strokeWidth}
              className="self-center justify-self-center"
            />
          )}
          {type === 'currency' && (
            <Coins
              size={size}
              strokeWidth={strokeWidth}
              className="self-center justify-self-center"
            />
          )}
          {type === 'season_pass' && (
            <Ticket
              size={size}
              strokeWidth={strokeWidth}
              className="self-center justify-self-center"
            />
          )}
        </div>
      </AppTooltip>
    </div>
  );
};
